import { RescheduleStep } from '@src/domains/sale-items/core/reschedule/types';

interface Params {
  currentStep: RescheduleStep;
  steps: RescheduleStep[];
  isWithDateOnly: boolean;
}

export function getNextRescheduleStep({ currentStep, steps, isWithDateOnly }: Params): RescheduleStep | undefined {
  const currentStepIndex = steps.indexOf(currentStep);
  const mustGoTwoStepsForward = isWithDateOnly && currentStep === RescheduleStep.Date;

  return steps[currentStepIndex + (mustGoTwoStepsForward ? 2 : 1)];
}
